import { buttonVariants } from "@/components/atoms/buttons";
import { Graphics } from "@/components/graphics";
import { Locales } from "@/lib/i18n";
import { __, getPermalink } from "@/lib/i18n/functions";
import { downloadInvoiceHandler } from "@/lib/invoice/download-invoice";
import { cn, convertDate, formatPrice } from "@/lib/utils";
import type { StoreOrder } from "@medusajs/types";
import { Loader2 } from "lucide-react";
import Link from "next/link";
import { useTransition } from "react";

interface OrderBodyMobileProps {
  order: StoreOrder;
  locale: Locales;
}

const OrderBodyMobile = ({ order, locale }: OrderBodyMobileProps) => {
  const [isPending, startTransition] = useTransition();

  return (
    <dl className="border-primary-light/50 space-y-4 border-b pb-5">
      <h4 className="text-lg font-medium break-words">{order?.id}</h4>
      <div className="flex items-center justify-between">
        <dt className="uppercase">{__("ORDER DATE", locale)}</dt>
        <dd className="font-medium capitalize">
          {order?.created_at ? convertDate(order?.created_at, "dd MMMM yyyy", locale) : "-"}
        </dd>
      </div>
      <div className="flex items-center justify-between">
        <dt className="uppercase">{__("NUMBER OF ITEMS", locale)}</dt>
        <dd className="font-medium">{order?.items?.length}</dd>
      </div>
      <div className="flex items-center justify-between">
        <dt className="uppercase">{__("AMOUNT", locale)}</dt>
        <dd className="font-medium">{formatPrice(order?.total)}</dd>
      </div>
      <div className="flex items-center justify-between">
        <dt className="uppercase">{__("INVOICE", locale)}</dt>
        <dd className="font-medium">
          <button
            disabled={isPending}
            onClick={() => startTransition(() => downloadInvoiceHandler(order.id, locale))}
            className="focus:outline-dark-primary inline-flex cursor-pointer items-center gap-2 p-1 disabled:pointer-events-none disabled:opacity-50"
          >
            {isPending ? <Loader2 className="animate-spin" size={28} /> : <Graphics.pdfIcon />}
          </button>
        </dd>
      </div>
      <Link
        href={`${getPermalink(locale, "account", "orders")}/${order.id}`}
        className={cn(
          buttonVariants({ variant: "secondary", size: "md" }),
          "border-primary-light/50 h-11 w-full border font-medium"
        )}
      >
        {__("View", locale)}
      </Link>
    </dl>
  );
};

export default OrderBodyMobile;
